import React from 'react';
import Footer from '../../layouts/Footer'; // Adjust the path as needed
import noResultsImage from '../../assets/sorry2.png'; // Adjust the path as needed

const NoResultsFound = () => {
  return (
    <div className="flex flex-col min-h-screen items-center justify-center bg-gray-100">
      <h5 className="text-lg text-center mt-5 mb-4">
        Oh no! There aren't any properties that match your search. Remove or update filters to find more properties.
      </h5>
      <img 
        src={noResultsImage} 
        alt="No Results Found" 
        className="img-fluid mb-4 h-50 w-100"
      />
      
      <Footer />
    </div>
  );
};

export default NoResultsFound;
